import { render, staticRenderFns } from "./MessageInfo.vue?vue&type=template&id=196618a4&scoped=true"
import script from "./MessageInfo.vue?vue&type=script&lang=js"
export * from "./MessageInfo.vue?vue&type=script&lang=js"
import style0 from "./MessageInfo.vue?vue&type=style&index=0&id=196618a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196618a4",
  null
  
)

export default component.exports